import { PLATFORM } from "../config/platform";

interface UpdateRequiredProps {
  /** Optional operator-written explanation from AppConfig.updateMessage. */
  message?: string | null;
}

// Shown when the bundle this tab is running is older than
// AppConfig.webappMinVersionCode. Unlike the mobile gate there is nothing to
// install — the fix is simply to fetch the current bundle — so the action is a
// hard reload rather than a store link.
//
// location.reload() alone can be served from cache, which would leave the user
// stuck on this screen pressing a button that does nothing. Adding a
// cache-busting query param guarantees a fresh document request.
const UpdateRequired = ({ message }: UpdateRequiredProps) => {
  const handleReload = () => {
    const url = new URL(window.location.href);
    url.searchParams.set("_v", Date.now().toString());
    window.location.replace(url.toString());
  };

  return (
    <div className="login">
      <div className="login__card">
        <h1>Update required</h1>
        <p className="login__sub">
          {message?.trim()
            ? message
            : `This tab is running an old version of ${PLATFORM.platform_name}. Reload to get the current one.`}
        </p>
        <p className="login__sub" style={{ marginTop: "0.5rem" }}>
          Version {__APP_VERSION__}
        </p>
        <button
          type="button"
          className="btn btn--primary"
          style={{ marginTop: "1rem" }}
          onClick={handleReload}
        >
          Reload now
        </button>
      </div>
    </div>
  );
};

export default UpdateRequired;
